export default __webpack_public_path__ + "static/media/NOW-07355_R.c06b66da.jpg";